import { useQuery } from '@tanstack/react-query';
import { orderNoteQueries } from '../api/order-note-queries';

/** Lazily fetch an order's notes (only when `enabled`, e.g. the dialog is open). */
export function useOrderNotes(orderId: string | number, enabled = true) {
  return useQuery(orderNoteQueries.list(orderId, enabled));
}
